import Typography from "@material-ui/core/Typography";
import './styles/work.css';

const TrackBillPrivacy = () => {
    return (
        <div className="WorkMain">
            <Typography variant="h3" gutterBottom>Privacy Policy – TrackBill</Typography>
            <Typography variant="body1" style={{ marginTop: '20px', whiteSpace: 'pre-wrap' }}>
                We do not collect, store, or share any personal data.
            </Typography>
            <Typography variant="body1" style={{ marginTop: '10px', whiteSpace: 'pre-wrap' }}>
                All information you enter in the app stays on your device and, if enabled, in your private iCloud storage.
            </Typography>
            <Typography variant="body1" style={{ marginTop: '10px', whiteSpace: 'pre-wrap' }}>
                We do not use analytics, tracking, advertising, or third-party data services.
            </Typography>
            <Typography variant="body1" style={{ marginTop: '20px', whiteSpace: 'pre-wrap' }}>
                If you have questions, contact:
            </Typography>
            <Typography variant="body1" style={{ marginTop: '5px', whiteSpace: 'pre-wrap' }}>
                hill.laurenz@gmx.de
            </Typography>
        </div>
    );
};

export default TrackBillPrivacy;